// extracted by mini-css-extract-plugin
export var container = "_6j-0";
export var error = "_6j-9";
export var label = "_6j-5";
export var light = "_6j-6";
export var md = "_6j-3";
export var sm = "_6j-2";
export var thin = "_6j-8";
export var thinBold = "_6j-7";
export var vertical = "_6j-4";
export var xs = "_6j-1";